<template>
    <div class="container">
        <!-- 添加团队 -->
        <div class="content" style="margin-top: 16px;">
            <div>
                <el-form :inline="true" :model="searchForm" size="small"  label-width="64px" class="search-form clearfix">
                    <el-form-item label="职位编号">
                        <el-input v-model="searchForm.positionCode" placeholder="请输入职位编号"></el-input>
                    </el-form-item>
                    <el-form-item label="职位描述">
                        <el-input v-model="searchForm.remark" placeholder="请输入职位描述"></el-input>
                    </el-form-item>
                    <el-form-item label="职位名称">
                        <el-input v-model="searchForm.positionName" placeholder="请输入职位名称"></el-input>
                    </el-form-item>
                    <el-form-item style="float: right;margin-right: 0;">
                        <div style="display: flex;">
                            <div class="s-btn" @click="fetchData('search')">查询</div>
                            <div class="r-btn" @click="fetchData('reset')">重置</div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="line"></div>
            <div class="data-title">
                <div style="display: flex;height: 32px;">
                    <div class="title-line"></div>
                    <div class="title-name">数据列表</div>
                </div>

                <div class="title-btn">
                    <div class="title-btn-item" v-if="parArray.indexOf('zwadd_oa') != -1" @click="add('0')">
                        <i class="el-icon-plus"></i>
                        <div class="btn-l">新增职位</div>
                    </div>
                </div>
            </div>
            <lb-table :column="column" :data="tableData" pagination :total="totalNum"
                layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                :current-page.sync="page.currentPage" :page-size="page.pageSize" @size-change="handleSizeChange"
                @p-current-change="handleCurrentChange">
            </lb-table>
        </div>
        <el-dialog :visible.sync="dialogFormVisible" :append-to-body="true" :title="title" width="600px">
            <el-form :model="form" :rules="rules" ref="form"  size="small" class="elForm" label-width="100px">
                <el-form-item label="职位编号" prop="positionName">
                    <el-input show-word-limit maxlength="12" v-model="form.positionName" placeholder="请输入职位编号"
                        size="small"></el-input>
                </el-form-item>
                <el-form-item  label="职位名称" prop="positionCode">
                    <el-input show-word-limit maxlength="12" v-model="form.positionCode" placeholder="请输入职位名称"
                        size="small"></el-input>
                </el-form-item>
                <el-form-item label="职位描述" prop="remark">
                    <el-input type="textarea" class="remark" show-word-limit maxlength="20" v-model="form.remark" placeholder="请输入职位描述"
                        size="small"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit()">确 定
                </el-button>
            </div>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="isConfirm" width="268px" append-to-body>
            <div style="font-size: 14px;color: #2F3030;line-height: 22px;text-align: center;margin-left:12px">
                是否确认删除该职位？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isConfirm = false">取 消</el-button>
                <el-button type="primary" @click="qDelete()">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import LbTable from '../../components/lb-table/lb-table'
export default {
    components: {
        LbTable
    },
    data() {
        return {
            isConfirm: false,
            dialogFormVisible: false,
            title: '新增职位',
            type: 'add',
            row: {},
            formInline: {
                name: "",
                code: "",
                remark: "",
            },
            select: [],
            selectType: [],
            tableData: [],
            totalNum: 0,
            currentPage1: 1,
            bumenId: "",
            lxId: "",
            limits: "",
            parArray: [],
            searchForm: {
                positionName: '',
                positionCode: '',
                remark: '',
                pageNo: 1,
                pageSize: 10,
            },
            form: {
                positionName: '',
                positionCode: '',
                remark: '',
                id: ''
            },
            rules: {
                positionName: [{ required: true, message: '请输入职位编号', trigger: 'blur' }],
                positionCode: [{ required: true, message: '请输入职位名称', trigger: 'blur' }],
                remark: [{ required: true, message: '请输入职位描述', trigger: 'blur' }]
            },
            page: {
                pageNo: 1,
                pageSize: 10,
                totalNum: 0,
                currentPage: 1,
            },
            totalNum: 0,
            column: [
                {
                    label: '序号',
                    width: 80,
                    prop: 'index',
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:center">{scope.$index + 1}</div>
                        )
                    }
                },
                {
                    label: '职位名称',
                    prop: 'positionName',
                    minWidth: 120,
                    renderHeader: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:flex-start">职位名称</div>
                        )
                    },
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:flex-start">{scope.row.positionName}</div>
                        )
                    }
                },
                {
                    label: '职位编码',
                    prop: 'positionCode',
                     minWidth: 180,
                    renderHeader: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:flex-start">职位编码</div>
                        )
                    },
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:flex-start">{scope.row.positionCode}</div>
                        )
                    }
                },
                {
                    label: '职位描述',
                    prop: 'remark',
                    minWidth: 140,
                    renderHeader: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:flex-start">职位描述</div>
                        )
                    },
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:flex-start">{scope.row.remark}</div>
                        )
                    }
                },
                {
                    label: '在职状态', prop: 'statusName', minWidth: 100,
                    render: (h, scope) => {
                        let vv = ''
                        if (scope.row.statusName == '正常') {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 8px;height: 8px;background: #00B498;;border-radius: 50%;opacity: 1;margin-top:9px;margin-right:4px"></div>
                                <div>{scope.row.statusName}</div>
                            </p>
                        } else {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 8px;height: 8px;background: #333333;border-radius: 50%;opacity: 1;margin-top:9px;margin-right:4px"></div>
                                <div>{scope.row.statusName}</div>
                            </p>
                        }
                        return (
                            <div> {vv}</div>

                            // <p style="color:#303033;font-size:14px;">{scope.row.verifyStatusLabel}</p>
                        )
                    }
                },
                {
                    label: '创建日期', prop: 'createdTime', minWidth:170,
                    renderHeader: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:flex-start">创建日期</div>
                        )
                    },
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:flex-start">{scope.row.createdTime}</div>
                        )
                    }
                },
                {
                    label: '操作', prop: 'orgName', width: 100,fixed:"right",
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:center">
                                {
                                    this.parArray.indexOf('zwbc_oa') != -1 ? <div
                                        style="color:#00B498;cursor:pointer;margin-right:8px"
                                        onClick={() => {
                                            this.add('1', scope.row);
                                        }}>编辑
                                    </div> : ""
                                }
                                {
                                    this.parArray.indexOf('zwdelect_oa') != -1 ? <div
                                        style="color:#f40713;cursor:pointer;"
                                        onClick={() => {
                                            this.delect(scope.row);
                                        }}>删除
                                    </div> : ""
                                }
                            </div >
                        )
                    }
                },
            ]
        };
    },
    created() {
        // this.positionList("1"); //查询职位列表
        // 权限设定判断 normsCode
        this.limits = JSON.parse(sessionStorage.getItem("limit"));
        const params = this.limits.buttonTreeDto.filter(
            (item) => item.menuCode === "position"
        );
        params[0].buttonList.forEach((item) => {
            this.parArray.push(item.code);
        });
        this.fetchData()
        // 权限设定判断 normsCode
    },
    activated() {
        // this.positionList("1");//查询职位列表
    },
    methods: {
        qDelete() {
            this.axios
                .post(
                    "/sys/v1/position/delete",
                    {
                        request: {
                            id: this.dId,
                            userId: sessionStorage.getItem("user_id"),
                        },
                        version: "",
                    },
                    {
                        headers: {
                            isLoading: false,
                        },
                    }
                )
                .then((res) => {
                    console.log(res);
                    if (res.code == 0) {
                        this.isConfirm = false
                        this.fetchData()
                        this.$message({
                            message: "删除成功",
                            type: "success",
                        });

                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        submit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (this.type == 'add') {
                        this.addposition()
                    } else {
                        this.fixPosition(this.form)
                    }

                } else {
                    return false;
                }

            })
        },
        add(val, row) {
            this.dialogFormVisible = true
            if (val == 0) {
                this.type = 'add'
                this.title = '新增职位'
                this.form.id = ''
                this.form.positionName = ''
                this.form.positionCode = ''
                this.form.remark = ''
            } else {
                this.type = 'edit'
                this.title = '编辑职位'
                this.form = row
            }
            this.$nextTick(() => {
                this.$refs["form"].clearValidate();
            });
        },
        handleCurrentChange(val) {
            this.page.pageNo = val
            this.fetchData()
        },
        handleSizeChange(sizeChange) {
            this.page.pageSize = sizeChange
            this.fetchData()
        },
        // 添加职位权限
        addposition() {
            this.axios
                .post(
                    "/sys/v1/position/add",
                    {
                        request: {
                            positionName: this.form.positionName,
                            positionCode: this.form.positionCode,
                            remark: this.form.remark,
                        },
                        version: "",
                    },
                    {
                        headers: {
                            isLoading: false,
                        },
                    }
                )
                .then((res) => {
                    // console.log(res)
                    if (res.code == 0) {
                        this.$message.success("添加成功");
                        this.fetchData();
                        this.dialogFormVisible = false
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        // 添加职位权限	 end
        limitsSelects() {
            this.$router.push({ name: "limitsSelects" });
        },
        fetchData(type) {
            if (type == 'reset') {
                this.searchForm = {
                    positionName: '',
                    positionCode: '',
                    remark: '',

                }
            }
            this.searchForm.pageNo = this.page.pageNo;
            this.searchForm.pageSize = this.page.pageSize;
            if (type == 'search') {
                this.searchForm.pageNo = 1
            }
            this.axios
                .post("/sys/v1/position/list", {
                    request: {
                        pageNo: this.searchForm.pageNo,
                        pageSize: this.searchForm.pageSize,
                        positionName: this.searchForm.positionName,
                        positionCode: this.searchForm.positionCode,
                        remark: this.searchForm.remark
                    },
                    version: "",
                })
                .then((res) => {
                    console.log(res);
                    if (res.code == 0) {
                        this.tableData = res.data.list;
                        this.totalNum = res.data.totalNum;
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        // 职位列表
        positionList(pageNo) {
            this.axios
                .post("/sys/v1/position/list", {
                    request: {
                        pageNo: pageNo,
                        pageSize: 10,
                        positionName: "",
                        positionCode: "",
                    },
                    version: "",
                })
                .then((res) => {
                    console.log(res);
                    if (res.code == 0) {
                        this.tableData = res.data;
                        this.tableData.totalNum = res.data.totalNum;
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        // 职位列表
        // 修改职位名称start
        fixPosition(row) {
            this.axios
                .post(
                    "/sys/v1/position/update",
                    {
                        request: {
                            id: row.id,
                            positionName: row.positionName,
                            positionCode: row.positionCode,
                            remark: row.remark,
                            userId: sessionStorage.getItem("user_id"),
                        },
                        version: "",
                    },
                    {
                        headers: {
                            isLoading: false,
                        },
                    }
                )
                .then((res) => {
                    // console.log('修改数据')
                    // console.log(res)
                    if (res.code == 0) {
                        this.$message.success("修改成功");
                        this.fetchData()
                        this.dialogFormVisible = false
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        // 修改职位名称end
        /***删除职位***/
        delect(row, index) {
            this.dId = row.id;
            this.isConfirm = true
        },
        /***删除职位 end***/
    },
};
</script>
  
<style scoped lang="scss">
.data-title {
    width: 100%;
    height: 32px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-line {
        width: 2px;
        height: 16px;
        background: #00B498;
        border-radius: 0px 0px 0px 0px;
        margin-top: 8px;
    }

    .title-name {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #2F3030;
        margin-left: 4px;
        line-height: 32px;
    }

    .title-btn {
        display: flex;

        .title-btn-item {
            width: 92px;
            height: 32px;
            background: #FFFFFF;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #E3E6E5;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 8px;
            padding-right: 8px;
            box-sizing: border-box;
            cursor: pointer;

            .btn-l {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #2F3030;

            }
        }


    }
}

.line {
    width: 100%;
    height: 1px;
    background: #EDF2F2;
    border-radius: 0px 0px 0px 0px;
    // margin-top: 16px;
}

// .div1 {
//     margin-left: -16px;
//     background: url(../../../assets/breadcrumb2.png);
//     width: 120px;
//     height: 30px;
//     text-align: center;
//     line-height: 30px;
//     color: #2d7edf;
// }

// .div2 {
//     margin-left: -16px;
//     background: url(../../../assets/breadcrumb1.png);
//     width: 120px;
//     height: 30px;
//     text-align: center;
//     line-height: 30px;
//     color: #fff;
// }

// .div3 {
//     margin-left: -8px;
//     background: url(../../../assets/breadcrumb3.png);
//     width: 120px;
//     height: 30px;
//     text-align: center;
//     line-height: 30px;
//     color: #2d7edf;
// }

.content {
    padding: 32px 16px 16px;
    background-color: #ffffff;
    min-height: calc(100vh - 118px);
    box-sizing: border-box;
    border-bottom: 32px solid #F5FAF9;
    border-radius: 8px 8px 8px 8px / 8px 8px 40px 40px;

    // .el-button {
    //     padding: 6px 10px;
    // }
}

.header {
    font-size: 16px;
    color: #00B498;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

.demo-form-inline {
    margin-top: 10px;
}

/deep/.el-input__inner {
    height: 30px;
    line-height: 30px;
}

.manage {
    margin-top: 20px;
    padding: 10px;
    background: #fff;
}

// /deep/.has-gutter .cell {
//     text-align: center;
//     color: #2d7ddf;
// }

// /deep/.cell {
//     text-align: center;
// }

.name {
    font-size: 16px;
    color: #00B498;
    margin: 10px 0;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #00B498;
    color: #FFF;
}

.optain {
    width: 100%;
    text-align: center;

    p {
        display: inline-block;
        vertical-align: middle;
        // margin-left: 20px;
        margin: 0 10px;
        color: #00B498;

        img {
            width: 18px;
            height: 20px;
            margin-top: 8px;
        }
    }
}

.page {
    text-align: right;
    margin-top: 20px;

    span {
        font-size: 15px;
        color: #666;
        display: inline-block;
        margin-left: 10px;
        vertical-align: middle;
    }

    .el-pagination {
        display: inline-block;
        vertical-align: middle;
    }
}

.vxe-header--row {
    background: #fff;
}
.elForm {
    padding: 20px 10px;
    /deep/{
        .el-input__inner,
        .el-textarea__inner{ 
            padding-left: 8px;
        }
        .el-form-item__label{
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
        }
    }
    
}
</style>
  